"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var classnames_1 = __importDefault(require("classnames"));
var ColumnsSetting_1 = __importDefault(require("./ColumnsSetting"));
var Sorting_1 = __importDefault(require("./Sorting"));
var Filter_1 = __importDefault(require("./Filter"));
var Title_1 = __importDefault(require("./Title"));
var useStyles_1 = __importDefault(require("./useStyles"));
var props_1 = require("../context/props");
var sorting_1 = require("../context/sorting");
var DataGridToolbar = function (_a) {
    var _b;
    var _c;
    var toolbarElement = _a.toolbarElement;
    var _d = (0, props_1.usePropsContext)(), isMobileHeader = _d.isMobileHeader, filter = _d.filter, actionsElement = _d.actionsElement, isColumnSettings = _d.isColumnSettings, classes = _d.classes;
    var hasSortingColumns = (0, sorting_1.useSortingContext)().hasSortingColumns;
    var internalClasses = (0, useStyles_1.default)();
    var hasMobileSorting = (0, react_1.useMemo)(function () { return (isMobileHeader && hasSortingColumns); }, [isMobileHeader, hasSortingColumns]);
    var hasMobileFilter = (0, react_1.useMemo)(function () { return (isMobileHeader && filter.mobileElement); }, [isMobileHeader, filter.mobileElement]);
    var hasDesktopFilter = (0, react_1.useMemo)(function () { return (!isMobileHeader && filter.desktopElement); }, [isMobileHeader, filter.desktopElement]);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)((_b = {},
            _b[internalClasses.container] = true,
            _b[((_c = classes === null || classes === void 0 ? void 0 : classes.toolbar) === null || _c === void 0 ? void 0 : _c.root) || ''] = true,
            _b)) },
        toolbarElement,
        react_1.default.createElement(Title_1.default, null),
        react_1.default.createElement(Grid_1.default, { container: true, wrap: "nowrap", justify: "space-between" },
            (hasMobileSorting || hasMobileFilter || hasDesktopFilter) && (react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                react_1.default.createElement(Grid_1.default, { container: true, wrap: "nowrap" },
                    hasMobileSorting && react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                        react_1.default.createElement(Sorting_1.default, null)),
                    hasMobileFilter && react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                        react_1.default.createElement(Filter_1.default, null)),
                    hasDesktopFilter && react_1.default.createElement(Grid_1.default, { item: true, xs: 12 }, filter.desktopElement)))),
            (actionsElement || isColumnSettings) && (react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                react_1.default.createElement(Grid_1.default, { container: true },
                    actionsElement && (react_1.default.createElement(Grid_1.default, { item: true }, actionsElement)),
                    isColumnSettings && (react_1.default.createElement(Grid_1.default, { item: true },
                        react_1.default.createElement(ColumnsSetting_1.default, null)))))))));
};
exports.default = DataGridToolbar;
